import { render, staticRenderFns } from "./nvLink.vue?vue&type=template&id=d88704d4&"
import script from "./nvLink.vue?vue&type=script&lang=js&"
export * from "./nvLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports